// src/store/modules/trades/actions.js

import { post, get } from '@/services/api';
export default {
  async updateTradeListPnL(context, payload) {
    console.log('📦 refresh pnl');
    try {
      const response = await post(`/trade/update-trade-list-pn-l`, payload);
      return response.data;
    } catch (error) {
      console.error('❌ Refresh Pnl API error:', error);
      throw error;
    }
  },
  async getTradePnLHistory({ commit }, { tradeId }) {
    try {
      console.log('📦 get trade pnl history', tradeId);
      const res = await get(`/trade/get-trade-pn-l-history?tradeId=${tradeId}`)
      console.log(`📦 Get Trade PnL History API response:`, res.data);
      return res.data
    } catch (err) {
      console.error('❌ Vuex getTradePnLHistory error:', err)
      throw err
    }
  },
  async createTrade(context, payload) {
    console.log('📦 create trades API called with payload:', payload);
    try {
      
      const requiredParams = ['startDate', 'niftyLevelAtStart', 'strategyName', 'strategyType'];
      const missingParams = requiredParams.filter(param => !payload[param]);
      
      if (missingParams.length > 0) {
        throw new Error(`Missing required parameters: ${missingParams.join(', ')}`);
      }
      console.log('📦 create trades API called with startdate:', payload.startDate);
      if (payload.startDate) {
        const [day, month, year] = payload.startDate.split('/');
        const date = new Date(`${year}-${month}-${day}`);
        payload.startDate = date.toISOString();
      }
      console.log('📦 create trades API called with startdate:', payload.startDate);

      const response = await post(`/trade/create-trade`, payload);
      return response.data;
    } catch (error) {
      console.error('❌ Create Trade API error:', error.response?.data || error.message);
      throw error;
    }
  },
  async markStrategy(context, payload) {
    console.log('📦 mark strategy');
    try {
      const response = await post(`/trade/mark-strategy`, payload);
      return response.data;
    } catch (error) {
      console.error('❌ Mark Strategy API error:', error);
      throw error;
    }
  },  
  async getAllPositionsWithoutStrategy() {
    console.log('📦 get all positions without strategy');
    try {
      const response = await get(`/trade/get-all-positions-without-strategy`);
      return response.data;
    } catch (error) {
      console.error('❌ Get All Positions without strategy API error:', error);
      throw error;
    }
  },  
  async getActiveTradeList({ commit }) {
    console.log('📦 called getActiveTradeList');
    try {
      const response = await get(`/trade/get-active-trade-list`);
      commit('setTradeList', response.data.tradeInfoList);  
      return response.data.tradeInfoList;
    } catch (error) {
      console.error('❌ Get Active Trade List API error:', error);
      throw error;
    }
  },
  async getActiveTradeDetailList() {
    console.log('📦 called getActiveTradeDetailList');
    try {
      const response = await get(`/trade/get-active-trade-detail-list`);
      console.log(`📦 Get Active Trade Detail List API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get Active Trade Detail List API error:', error);
      throw error;
    }
  },
  
  async getAllPositionsWithStrategy() {
    console.log('📦 get all positions with strategy');
    try {
      const response = await get(`/trade/get-all-positions-with-strategy`);
      console.log(`📦 Get All Positions with strategy API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get All Positions with strategy API error:', error);
      throw error;
    }
  },  
  async markPositionClose(context, payload) {
    console.log('📦 mark Position close in action', payload);
    try {
      const response = await post(`/order/mark-position-close`, {
        optionPositionsId: payload.optionPositionsId,
        exitPrice: payload.exitPrice
      });
      console.log(`📦 Mark Position Close API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Mark Position Close API error:', error);
      throw error;
    }
  },
  async markPositionOpen(context, payload) {
    console.log('📦 mark Position open in action', payload);
    try {
      const response = await post(`/order/mark-position-open`, {
        optionPositionsId: payload.optionPositionsId
      });
      console.log(`📦 Mark Position Open API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Mark Position Open API error:', error);
      throw error;
    }
  },
  async removeOrderFromPosition(context, payload) {
    console.log('📦 remove Order from position in action', payload);
    try {
      const response = await post(`/order/remove-order-from-position`, {
        optionPositionsId: payload.optionPositionsId
      });
      console.log(`📦 Remove Order from Position API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Remove Order from Position API error:', error);
      throw error;
    }
  },
  async getMarginList(context, payload) {
    console.log('📦 get margin list in action', payload);
    try {
      const response = await get(`/user/get-margin-list`);
      console.log(`📦 get margin list API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ get margin list API error:', error);
      throw error;
    }
  },
  async refreshNiftyLevel(context, payload) {
    console.log('📦 refresh nifty level in action', payload);
    try {
      const response = await post(`/indicators/refresh-nifty-level`);
      console.log(`📦 refresh nifty level API response:`, response.data);
      return {
        niftyLevel: response.data.niftyLevel,
        previousDayNiftyLevel: response.data.previousDayNiftyLevel,
      }
    } catch (error) {
      console.error('❌ refresh nifty level API error:', error);
      throw error;
    }
  },
  async getExitedTradeDetailList(context, payload) {
    console.log('📦 get past trades in action', payload);
    try {
      const response = await get(`/trade/get-exited-trade-detail-list`, {
        params: payload,   // ✅ pass payload as params
      });
      console.log('📦 get past trades API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ get past trades API error:', error);
      throw error;
    }
  },
  async getExitedFreeTradeDetailList(context, payload) {
    console.log('📦 get past free trades in action', payload);
    try {
      const response = await get(`/trade/get-exited-free-trade-detail-list`, {
        params: payload,   // ✅ pass payload as params
      });
      console.log('📦 get past free trades API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ get past free trades API error:', error);
      throw error;
    }
  },
  async markTradeExited (context, payload) {   
    console.log('📦 mark trade exited in action', payload);
    try {
      const response = await post(`/trade/mark-trade-exited`, payload);
      console.log(`📦 mark trade exited API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ square off the trade API error:', error);
      throw error;
    }
  },
  async removePositionFromTrade (context, payload) {   
    console.log('📦 remove position from trade in action', payload);
    try {
      const response = await post(`/trade/remove-position-from-trade`, payload);
      console.log(`📦 remove position from trade API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ remove position from trade API error:', error);
      throw error;
    }
  }
}
;
